import type { EditorClip } from '../core/models/editor-clip.model';
import { clipContainsTime } from '../core/utils/timeline-math.util';

/**
 * While authoring, an entrance animation can make the selected design completely
 * transparent on its insertion frame. Reveal only that paused, selected design in
 * its settled pose; playback and export still evaluate the real entrance motion.
 */
export function shouldRevealSelectedTextDesignAtStart(
  clip: EditorClip,
  timeSeconds: number,
  isPlaying: boolean,
  selectedClipId: string | null | undefined,
): boolean {
  if (isPlaying || selectedClipId !== clip.id || !clip.textDesign) return false;
  const entrance = clip.animateIn;
  if (!entrance || entrance.preset === 'none' || entrance.durationSeconds <= 0) return false;

  // Timeline values are rounded to tenths when clips are inserted, while the
  // playhead can carry sub-frame decimals. Half that 0.1s quantization interval
  // keeps insertion rounding harmless without masking a deliberate later scrub.
  return Math.abs(timeSeconds - clip.startSeconds) <= 0.051;
}

/** Timeline-active designs plus the narrow paused authoring exception above. */
export function shouldDrawTextDesignInPreview(
  clip: EditorClip,
  timeSeconds: number,
  isPlaying: boolean,
  selectedClipId: string | null | undefined,
): boolean {
  return clipContainsTime(clip, timeSeconds)
    || shouldRevealSelectedTextDesignAtStart(clip, timeSeconds, isPlaying, selectedClipId);
}
